/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {
  AE_PAYMENT_TYPES,
} from "@auex/configurations";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class AcceptedPaymentMethods extends Component {
  static propTypes = {
    paymentMethods: PropTypes.array,
  };

  static contextTypes = {
    __: PropTypes.func.isRequired,
  };

  static defaultProps = {
    paymentMethods: [],
  };

  paymentMethodNames = new Map([
    [AE_PAYMENT_TYPES.AMEX, this.context.__("paymentMethods::sources.amex")],
    [
      AE_PAYMENT_TYPES.BANKDRAFT,
      this.context.__("paymentMethods::sources.bdft"),
    ],
    [
      AE_PAYMENT_TYPES.CERTIFIED_CHEQUE,
      this.context.__("paymentMethods::sources.cchq"),
    ],
    [AE_PAYMENT_TYPES.CHEQUE, this.context.__("paymentMethods::sources.pchq")],
    [
      AE_PAYMENT_TYPES.MASTERCARD,
      this.context.__("paymentMethods::sources.mast"),
    ],
    [AE_PAYMENT_TYPES.SPECIE, this.context.__("paymentMethods::sources.cash")],
    [
      AE_PAYMENT_TYPES.TRANSFER,
      this.context.__("paymentMethods::sources.btra"),
    ],
    [AE_PAYMENT_TYPES.VISA, this.context.__("paymentMethods::sources.visa")],
  ]);

  renderPaymentMethods = () => {
    const {
      __,
    } = this.context;

    const {
      paymentMethods,
    } = this.props;

    // No methods of payment.
    if (!paymentMethods.length) {
      return (
        <em>
          {__("organization::noMethodsOfPayment")}
        </em>
      );
    }

    // Only one method of payment.
    if (paymentMethods.length === 1) {
      return this.paymentMethodNames.get(paymentMethods[0]);
    }

    // Two or more methods of payment.
    return (
      <ul>
        {paymentMethods.map((type, index) => (
          <li key={index}>
            {this.paymentMethodNames.get(type)}
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const {
      __,
    } = this.context;

    const {
      paymentMethods,
    } = this.props;

    return (
      <div>
        <h6>
          {__(
            "organization::methodsOfPayment",
            {count: paymentMethods.length === 1 ? 1 : 2},
          )}
        </h6>
        {this.renderPaymentMethods()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../components/AcceptedPaymentMethods.jsx